<template>
  <div class="trackPlaybackBox">
    <!-- 左边单位人员设备卡片区域 -->
    <div class="leftBox">
      <!-- 单位人员设备树 -->
      <mytree
        class="treeBox"
        :data="ArchInfo"
        :props="defaultTreesProps"
        show-checkbox
        default-expand-all
        :expand-on-click-node="false"
        :highlight-current="true"
        node-key="name"
        ref="navTree"
        @check-change="getCheckedDevicesNodes"
      >
        <!-- :render-content="renderContent"  -->
        <span slot-scope="{ node, data }">
          <div class="bigTree">
            <div class="leftTree">
              <div>
                <!-- 单位图标 -->
                <img
                  v-show="data.type == 1"
                  style="width: 24px; height: 24px; margin-right: 2px"
                  src="../../../assets/img/tree/dw.svg"
                />
                <!-- 人员图标 -->
                <img
                  v-show="data.type == 2"
                  style="width: 24px; height: 24px; margin-right: 2px"
                  src="../../../assets/img/tree/ry.svg"
                />
                <!-- 执法仪不在线图标 -->
                <img
                  v-show="data.type == 3 && data.status.online == false"
                  style="width: 24px; height: 24px"
                  :src="
                    data.devideType == 1
                      ? require('../../../assets/img/tree/zfy.svg')
                      : data.devideType == 2
                      ? require('../../../assets/img/tree/bkq.svg')
                      : data.devideType == 3
                      ? require('../../../assets/img/tree/aqm.svg')
                      : data.devideType == 4
                      ? require('../../../assets/img/tree/wrj.svg')
                      : data.devideType == 5
                      ? require('../../../assets/img/tree/jksxj.svg')
                      : require('../../../assets/img/tree/zngb.svg')
                  "
                />
                <!-- 执法仪在线图标 -->
                <img
                  v-show="data.type == 3 && data.status.online == true"
                  style="width: 24px; height: 24px"
                  :src="
                    data.devideType == 1
                      ? require('../../../assets/img/tree/zfy_online.svg')
                      : data.devideType == 2
                      ? require('../../../assets/img/tree/bkq_online.svg')
                      : data.devideType == 3
                      ? require('../../../assets/img/tree/aqm_online.svg')
                      : data.devideType == 4
                      ? require('../../../assets/img/tree/wrj_online.svg')
                      : data.devideType == 5
                      ? require('../../../assets/img/tree/jksxj_online.svg')
                      : require('../../../assets/img/tree/zngb_online.svg')
                  "
                />
              </div>

              <!-- 设备名称 -->
              <el-tooltip
                v-show="data.type == 3"
                class="item"
                effect="dark"
                :content="node.label"
                placement="top"
              >
                <div ref="nodeLabel">
                  <div v-if="node.label.length > 8">
                    {{
                      node.label.replace(
                        /(\d{3})\d*([0-9a-zA-Z]{3})/,
                        "$1***$2"
                      )
                    }}
                  </div>
                  <div v-else>
                    {{ node.label }}
                  </div>
                </div>
              </el-tooltip>

              <!--  -->
              <!-- 单位和人员名称 -->
              <div ref="nodeLabel" v-show="data.type == 1 || data.type == 2">
                {{ node.label }}
              </div>
            </div>
          </div>
        </span>
      </mytree>
    </div>
    <div id="map"></div>
    <ul class="drawing-panel">
      <el-date-picker
        v-model="Time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd HH:mm:ss"
        align="left"
        :pickerOptions="pickerOptions"
      >
        <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
      </el-date-picker>

      <el-button class="btn" @click="reset()">重置</el-button>
      <el-button class="btn" @click="pause()">
        {{ this.pauseOrStart == false ? "停止" : "继续" }}
      </el-button>
      <el-button class="btn" @click="run()">开始</el-button>
      <el-select v-model="speeds" style="width: 100px" placeholder="请选择">
        <el-option
          v-for="item in speedOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <!-- <select class="btn" id="speed">
        <option value="100">请选择</option>
        <option value="6500">超级快</option>
        <option value="5500">很快</option>
        <option value="1500">很慢</option>
        <option value="50">超级慢</option>
      </select> -->
    </ul>

    <!-- <button @click="reset">重置</button> -->
  </div>
</template>

<script>
// 引入百度地图样式
import custom_map_config from "../../../assets/css/custom_map_config4.json";
// 修改el-tree 只能node.data.type ==3 的才出现复选框
import mytree from "../../../tree/src/tree.vue";
export default {
  components: {},
  data() {
    return {
      map: null,
      glpoints: [],
      points: [],
      // 单位人员设备树信息
      ArchInfo: [],
      // 组织架构信息显示树形控件
      defaultTreesProps: {
        children: "children",
        label: "name",
      },
      // 查询轨迹参数
      trackInfo: {
        beginTime: "", //开始时间
        endTime: "", //结束时间
        deviceNumber: "", //设备编号
      },
      // 轨迹回放人员
      empName: "",
      // 时间选择器选择的时间
      Time: "",
      // 时间选择器
      choiceDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          // 把选择的第一个日期赋值给一个变量。
          this.choiceDate = minDate.getTime();
          // 如何你选择了两个日期了，就把那个变量置空
          if (maxDate) this.choiceDate = "";
        },
        disabledDate: (time) => {
          // 如何选择了一个日期
          if (this.choiceDate) {
            // 7天的时间戳
            const one = 6 * 24 * 3600 * 1000;
            // 当前日期 - one = 7天之前
            const minTime = this.choiceDate - one;
            // 当前日期 + one = 7天之后
            const maxTime = this.choiceDate + one;
            return (
              time.getTime() < minTime ||
              time.getTime() > maxTime ||
              // 限制不能选择今天及以后
              time.getTime() + 3600 * 10 > Date.now()
            );
          } else {
            // 如果没有选择日期，就要限制不能选择今天及以后
            return time.getTime() + 3600 * 10 > Date.now();
          }
        },
      },

      marker: null,
      currentIndex: 0,
      intervalId: null,
      speed: 10000,
      trackAni: "",
      pl: "",
      // 控制暂停和继续开始
      pauseOrStart: false,
      speeds: 50,
      speedOptions: [
        {
          value: 5,
          label: "-3倍速度",
        },
        {
          value: 10,
          label: "-2倍速度",
        },
        {
          value: 20,
          label: "-1倍速度",
        },

        {
          value: 50,
          label: "1倍速度",
        },
        {
          value: 100,
          label: "2倍速度",
        },
        {
          value: 150,
          label: "3倍速度",
        },
      ], //控制轨迹播放速度
    };
  },
  components: {
    mytree,
  },
  computed: {},
  created() {
    // 获取单位人员设备树
    this.getDepPersonDevTree();
  },
  mounted() {
    // 初始化地图
    this.initMap();
  },
  methods: {
    //  获取组织架构信息
    async getDepPersonDevTree() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/getDepPersonDevTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.ArchInfo = res.data;
    },

    //获取tree选中的设备devIds
    getCheckedDevicesNodes(data, check) {
      // 只能单选
      if (check) {
        this.$refs.navTree.setCheckedNodes([data]); // 选中已选中节点
      }
      var devices = this.$refs.navTree.getCheckedNodes();
      if (devices.length > 0) {
        var devIds = [];
        for (let i = 0; i < devices.length; i++) {
          const element = devices[i];
          if (element.type == 3) {
            devIds.push(element.name);
          }
        }
        this.trackInfo.deviceNumber = devIds[0];
      }
    },

    initMap() {
      this.map = new BMapGL.Map("map", { enableMapClick: false });
      setTimeout(() => {
        this.map.centerAndZoom(new BMapGL.Point(111.38874, 31.996516), 5);
      }, 1000);
      this.map.enableScrollWheelZoom(); // 启用滚轮放大缩小。
      this.map.enableKeyboard(); // 启用键盘操作。
      this.map.enableContinuousZoom(); //启用连续缩放效果
      //地图个性化样式
      this.map.setMapStyleV2({
        // styleId: "a0c43e8c7279db0a4a032712d0e4c32c", //官网地图api个性化获取
        // styleJson:[{}] //也可以json方式个性化
        styleJson: custom_map_config,
      });
    },
    async run() {
      // 清除地图覆盖图层
      this.map.clearOverlays();
      if (this.trackAni) {
        this.trackAni = "";
        this.glpoints = [];
      }
      if (!this.Time) {
        return this.$message.warning("请选择轨迹回放的时间范围");
      } else if (this.trackInfo.deviceNumber == "") {
        return this.$message.warning("请选择对应设备");
      }
      await this.getTrack();

      if (this.points.length == 0) {
        return this.$message.warning("该时间段无轨迹");
      }
      var time = [];
      // console.log(this.points);
      for (let i = 0; i < this.points.length; i++) {
        var lng = this.points[i].lng;
        var lat = this.points[i].lat;
        time.push(this.points[i].time);
        var point = this.wgs84ToBd09(lng, lat);
        // console.log("point", point);
        var bdlng = point[0];
        var bdlat = point[1];
        this.glpoints.push(new BMapGL.Point(bdlng, bdlat));
      }
      this.map.addOverlay(
        new BMapGL.Polyline(this.glpoints, {
          strokeColor: "red",
          strokeWeight: 5,
          strokeOpacity: 0.7,
        })
      );
      this.map.setViewport(this.glpoints);
      //起点
      var marker = new BMapGL.Marker(
        new BMapGL.Point(this.glpoints[0].lng, this.glpoints[0].lat)
      );
      var iconc = new BMapGL.Icon(
        "../static/images/map/start.png",
        new BMapGL.Size(50, 50)
      );
      marker.setIcon(iconc);
      this.map.addOverlay(marker); //将标记添加到地图中
      // 终点
      marker = new BMapGL.Marker(
        new BMapGL.Point(
          this.glpoints[this.glpoints.length - 1].lng,
          this.glpoints[this.glpoints.length - 1].lat
        )
      );
      iconc = new BMapGL.Icon(
        "../static/images/map/end.png",
        new BMapGL.Size(50, 50)
      );
      marker.setIcon(iconc);
      this.map.addOverlay(marker); //将标记添加到地图中
      this.trackAni = new BMapGLLib.LuShu(this.map, this.glpoints, {
        defaultContent: this.empName + "(" + this.trackInfo.deviceNumber + ")", //"标签内容"
        autoView: true, //是否开启自动视野调整，如果开启那么路书在运动过程中会根据视野自动调整
        icon: new BMapGL.Icon(
          "../static/images/map/user.png",
          new BMapGL.Size(50, 50),
          {
            anchor: new BMapGL.Size(15, 15),
          }
        ),
        speed: this.speeds, //覆盖物移动速度，单位米/秒
        landmarkPois: [],
        // enableRotation: true, //是否设置marker随着道路的走向进行旋转
      });
      this.trackAni.start();
    },
    // 获取轨迹
    async getTrack() {
      this.trackInfo.beginTime = "";
      this.trackInfo.endTime = "";
      if (this.Time) {
        // 开始时间
        this.trackInfo.beginTime = this.Time[0];
        // 结束时间
        this.trackInfo.endTime = this.Time[1];
      }
      const { data: res } = await this.$axios.get(
        `${this.$api}/position/history`,
        { params: this.trackInfo }
      );

      if (res.status != 0) {
        return this.$message.error(res.msg);
      }

      if (res.data.positionList.length == 0) {
        return this.$message.warning("该时间段无轨迹");
      }
      // 人员
      this.empName = res.data.empName;
      this.points = res.data.positionList.filter((item, index, arr) => {
        if (index === 0) {
          // 如果是第一个对象，则不保留
          return false;
        } else {
          // 检查当前对象与前一个对象的lat和lng是否都相等
          const prevObj = arr[index - 1];
          return (
            (item.lng !== 0 || item.lat !== 0) &&
            item.lng !== prevObj.lng &&
            item.lat !== prevObj.lat
          );
        }
      });

      // 检查最后一个对象的lng和lat是否都为0
      if (this.points.length > 0) {
        const lastObj = this.points[this.points.length - 1];
        if (lastObj.lng === 0 && lastObj.lat === 0) {
          this.points.pop(); // 移除最后一个对象
        }
      }

      // for (var i = 0; i < this.points.length; i++) {
      //   if (this.points[i].lng != 0 && this.points[i].lat != 0) {
      //     this.glpoints.push(
      //       new BMap.Point(this.points[i].lng, this.points[i].lat)
      //     );
      //   }
      // }

      // let length = res.data.length;
      // let tmp = new Array(length);
      // let index = 0;
      // for (let i = 0; i < length; i++) {
      //   let lng = res.data[i].lng;
      //   let lat = res.data[i].lat;
      //   if (lng == 0 && lat == 0) {
      //     continue;
      //   }
      //   if (index == 0) {
      //     tmp[index++] = new BMapGL.Point(lng, lat);
      //   } else {
      //     let preLng = tmp[index - 1].lng;
      //     let preLat = tmp[index - 1].lat;
      //     if (preLng != lng || preLat != lat) {
      //       tmp[index++] = new BMap.Point(lng, lat);
      //     }
      //   }
      // }
      // this.glpoints = tmp.slice(0, index);
      // console.log("this.glpoints", this.glpoints);
    },

    // 将wgs84转换成Bd09坐标系
    wgs84ToBd09(lng, lat) {
      var PI = (3.14159265358979324 * 3000.0) / 180.0;
      var x = parseFloat(lng),
        y = parseFloat(lat);
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * PI);
      // var bdLng = z * Math.cos(theta) + 0.0065;
      // var bdLat = z * Math.sin(theta) + 0.006;
      var bdLng = z * Math.cos(theta) + 0.0116;
      var bdLat = z * Math.sin(theta) + 0.0032;
      return [bdLng, bdLat];
    },

    // play() {
    //   // var point = [];
    //   // for (var i = 0; i < this.points.length; i++) {
    //   //   if (this.points[i].lng != 0 && this.points[i].lat != 0) {
    //   //     point.push(new BMapGL.Point(this.points[i].lng, this.points[i].lat));
    //   //   }
    //   // }
    //   var p = this.glpoints;
    //   // var p2 = p.slice(0, 20);
    //   if (p.length != 0) {
    //     this.pl = new BMapGL.Polyline(p, {
    //       strokeColor: "red",
    //       strokeWeight: 5,
    //       strokeOpacity: 1,
    //     });
    //   }

    //   // var icon = require("../../../assets/img/trackPlayback/car.png");
    //   this.trackAni = new BMapGLLib.TrackAnimation(this.map, this.pl, {
    //     overallView: true, // 动画完成后自动调整视野到总览
    //     tilt: 30, // 轨迹播放的角度，默认为55
    //     duration: this.speed, // 动画持续时长，默认为10000，单位ms
    //     delay: 3000, // 动画开始的延迟，默认0，单位ms
    //     enableRotation: true, // 是否设置marker随着道路的走向进行旋转
    //   });
    //   this.trackAni.start();
    // },

    // 控制轨迹移动暂停
    pause() {
      if (this.trackAni) {
        if (this.pauseOrStart != false) {
          this.trackAni.start();
          this.pauseOrStart = false;
        } else {
          this.trackAni.pause();
          this.pauseOrStart = true;
        }
      }
    },
    // 重置
    reset() {
      if (this.trackAni) {
        this.map.clearOverlays();
        this.trackInfo.deviceNumber = "";
        this.trackInfo.endTime = "";
        this.trackInfo.beginTime = "";
        this.Time = "";
        this.glpoints = [];
        this.$refs.navTree.setCheckedNodes([]);
        this.speeds = 50;
        this.trackAni.stop();
        this.trackAni = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.trackPlaybackBox {
  /* position: relative; */
  width: 100%;
  height: calc(100vh - 101px);
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
#map {
  width: 100%;
  height: 100%;
}
ul li {
  list-style: none;
}
.drawing-panel {
  z-index: 999;
  position: fixed;
  bottom: 3.5rem;
  right: 3rem;
  padding: 1rem 1rem;
  border-radius: 0.25rem;
  background-color: #10c0f6a4;
  box-shadow: 0 2px 6px 0 rgba(27, 142, 236, 0.5);
}
.btn {
  width: 90px;
  height: 40px;
  float: right;
  background-color: #0b67fccc;
  color: rgb(2, 252, 252);
  font-size: 14px;
  border: 1px solid rgba(27, 142, 236, 1);
  border-radius: 5px;
  margin: 0 5px;
  text-align: center;
  // line-height: 40px;
}
.btn:hover {
  background-color: rgba(4, 136, 244, 0.922);
  color: #fff;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 90px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 45px 10px 20px 10px;
  height: calc(100vh - 195px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
  display: flex;
}

.bigTree {
  height: 26px;
  display: flex;
}
.leftTree {
  width: 95%;
  display: flex;
  vertical-align: center;
  align-items: center;
}

.rightTree {
  position: relative;
  right: 0px;
  margin-left: 5px;
  /* width: 1%; */
  vertical-align: center;
}

/* 隐藏父级节点选框 */
/deep/.el-tree .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner {
  display: inline-block;
}
/deep/.el-tree .el-tree-node .el-checkbox .el-checkbox__inner {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/EvidenceCenter/trackPlayback.vue